import { createContext } from 'react';
export var SideNavigationContext = createContext({
  activeRoute: '',
  setActiveRoute: function setActiveRoute() {},
  isCollapsed: false,
  expand: function expand() {},
  collapse: function collapse() {}
});